import { lazy } from 'react';

export default {
  exact: false,
  name: 'cashout-for-myself',
  protected: true,
  path: '/cashout-for-myself',
  component: lazy(() =>
    import('containers/GatewayCashout/forMyself'),
  ),
};
